<template>
  <component :is="`h${h}`">
    <slot />
  </component>
</template>

<script setup lang="ts">
defineProps<{
  h: 3 | 4 | 5 | 6;
}>();
</script>

<style scoped>
h3 {
  font-size: 26px;
  margin-bottom: var(--space-6);
}
h4 {
  font-size: 20px;
}
h5 {
  margin-bottom: var(--space-3);
}
</style>